import { useState, React } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './SignUpPage.css';
import { useToken } from '../../auth/useToken';

export const SignUpPage = () => {
  const [token, setToken] = useToken();
  const [errorMessage, setErrorMessage] = useState('');

  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const onSignUpClicked = async () => {
    if (formValues.password !== formValues.confirmPassword) {
      setErrorMessage("Passwords do not match!");
      return;
    }

    try {
      const response = await axios.post('/api/signup', {
        first_name: formValues.firstName,
        last_name: formValues.lastName,
        email: formValues.email,
        password: formValues.password,
      });
      const { token } = response.data;
      setToken(token);
      navigate('/verify-email');
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Something went wrong. Please try again."
      );
    }
  };

  return (
    <div className="content-container">
      <h1>Sign Up</h1>
      {errorMessage && <div className="fail">{errorMessage}</div>}
      <input
        name="firstName"
        value={formValues.firstName}
        onChange={handleInputChange}
        placeholder="John"
      />
      <input
        name="lastName"
        value={formValues.lastName}
        onChange={handleInputChange}
        placeholder="Doe"
      />
      <input
        name="email"
        type="email"
        value={formValues.email}
        onChange={handleInputChange}
        placeholder="someone@gmail.com"
      />
      <input
        name="password"
        type="password"
        value={formValues.password}
        onChange={handleInputChange}
        placeholder="password"
      />
      <input
        name="confirmPassword"
        type="password"
        value={formValues.confirmPassword}
        onChange={handleInputChange}
        placeholder="confirm password"
      />
      <hr />
      <button
        disabled={
          !formValues.email ||
          !formValues.password ||
          formValues.password !== formValues.confirmPassword
        }
        onClick={onSignUpClicked}
      >
        Sign Up
      </button>
      <button onClick={() => navigate('/login')}>Already have an account? Log In</button>
    </div>
  );
};
